import script from "./SupplierModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierModal.vue?vue&type=script&setup=true&lang=js"

import "./SupplierModal.vue?vue&type=style&index=0&id=571a6099&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571a6099"]])

export default __exports__